import React from "react";
import PropTypes from "prop-types";

import StructuredData from "components/microData/StructuredData";
import MicroDataMedicalWebPage from "components/microData/MedicalWebPage";

class MedicalWebPage extends MicroDataMedicalWebPage {
    _isProprietary() {
        return this.props.productType === "original";
    }

    _isAvailableGenerically() {
        return Boolean(this.props.generic);
    }

    _isAvailableOriginal() {
        return Boolean(this.props.original);
    }

    _getSchemaWithGenerics() {
        let result = this._getSchema();

        Object.assign(result, {
            about: {
                "@type": "Drug",
                name: this.props.name,
                isProprietary: this._isProprietary()
            }
        });

        if (this._isProprietary() && this._isAvailableGenerically()) {
            result.about = {
                ...result.about,
                isAvailableGenerically: true,
                nonProprietaryName: this.props.generic?.name
            };
        }

        if (!this._isProprietary() && this._isAvailableOriginal()) {
            result.about = {
                ...result.about,
                isAvailableGenerically: true,
                proprietaryName: this.props.original?.name
            };
        }

        if (this._hasImage()) {
            result.about = {
                ...result.about,
                image: {
                    "@type": "ImageObject",
                    url: this._getImageUrl()
                    // width: "",
                    // height: ""
                }
            };
        }

        return result;
    }

    render() {
        return <StructuredData schema={this._getSchemaWithGenerics()} />;
    }
}

MedicalWebPage.propTypes = {
    generic: PropTypes.instanceOf(Object) || null,
    brands: PropTypes.instanceOf(Array),
    productType: PropTypes.string,
    original: PropTypes.instanceOf(Object) || null
};

MedicalWebPage.defaultProps = {
    generic: null,
    brands: [],
    productType: "",
    original: null
};

export default MedicalWebPage;
